import { render, staticRenderFns } from "./ProductBulkImageList.vue?vue&type=template&id=844b1e84&"
import script from "./ProductBulkImageList.vue?vue&type=script&lang=ts&"
export * from "./ProductBulkImageList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBulkImageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports